export const GET_USERS = {type: "GET_USERS"}

export const SET_USERS = (setUsers) => {
    return {type: "SET_USERS", users: setUsers}
}